// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`CheckItem test Match con el snapshot 1`] = `""`;
